<img *ngIf="qrCodeDataUrl" [width]="width" [height]="width" [src]="qrCodeDataUrl" />
